import {SET_SUBSCRIPTION} from '../actions/constant';
import {deepCopy} from '../utils/objects';

const initialState = {};

export default function subscription(state = initialState, action = {}) {
  const {type, payload = {}} = action;

  if (type === SET_SUBSCRIPTION) {
    const {organisationId, date} = payload;
    if (!organisationId) { return state; }
    return {
      ...state,
      [organisationId]: date ? {date} : deepCopy(payload.subscription)
    };
  }

  return state;
}
